import React, { useState, useEffect } from "react";
//import { DialogBox } from "../../../../../components/Elements/DialogBox";
import { DialogBox } from "../../../../components/Elements/DialogBox";
import { Select } from "antd";
import CustomButton from "../../../../components/Elements/Buttons/CustomButtons";

const FilterAssignedForm = ({ onOpen, onClose, onApplyFilter, filterData }) => {
  const [status, setStatus] = useState(filterData?.status || "");

  useEffect(() => {
    setStatus(filterData?.status || "");
  }, [filterData]);

  const statusOptions = [
    { label: "All", value: "" },
    { label: "Assigned", value: "Assigned" },
    { label: "Form Filling Completed", value: "Form Filling Completed" },
    { label: "Access Paused", value: "Access Paused" },
    { label: "Access Removed", value: "Access Removed" },
  ];

  const handleSearch = () => {
    if (onApplyFilter) {
      onApplyFilter({ status });
    }
    onClose();
  };

  const handleReset = () => {
    setStatus("");
    if (onApplyFilter) {
      onApplyFilter({ status: "" });
    }
    onClose();
  };

  return (
    <div>
      <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="700px">
        <div>
          <h3 className="text-xl font-bold text-[#06513D]">Filter</h3>
        </div>

        <div className="flex flex-col w-full mt-6">
          <label className="text-sm font-medium text-gray-700 mb-2">
            Status
          </label>
          <Select
            value={status}
            onChange={setStatus}
            placeholder="SELECT STATUS"
            className="w-full text-base font-light min-h-[48px]"
            allowClear
          >
            {statusOptions.map((option) => (
              <Select.Option key={option.value} value={option.value}>
                {option.label}
              </Select.Option>
            ))}
          </Select>
        </div>

        <div className="flex justify-center gap-4 py-6">
          <CustomButton
            buttonType="primary"
            variant="cancel"
            buttonText="Reset"
            className="text-sm px-6 py-2 rounded-lg"
            onClick={handleReset}
          />
          <CustomButton
            buttonType="primary"
            variant="ok"
            buttonText="Search"
            className="text-sm px-6 py-2 rounded-lg"
            onClick={handleSearch}
          />
        </div>
      </DialogBox>
    </div>
  );
};

export default FilterAssignedForm;
